<template>
  <div class="grid-x flex-grow">
    <Loading class="flex-grow" :loading="waitPending">
      <div class="cell auto cell-block-y flex flex-col flex-grow">
        <div class="flex flex-col flex-grow">
          <UserProfile
            :payload="contractor"
            :pins="pins"
          >
            <template v-if="contractor && typeof contractor.balance !== 'undefined'" #subheader>
              <div class="py-6 px-8 flex flex-col items-start space-y-4">
                <div>
                  <span class="font-bold">Максимальное количество заказов:</span>&nbsp;
                  <span class="text-xl font-bold">
                    {{ contractor.maxActiveOrders }}
                  </span>
                </div>
                <div>
                  <span class="font-bold">Баланс:</span>&nbsp;
                  <span class="text-xl font-bold">
                    {{ $numeral(parseFloat(contractor.balance)).format('0,0.00') }}
                  </span>
                </div>
                <div class="flex items-stretch">
                  <FormInput
                    placeholder="0,0"
                    :inputmask="{
                      alias: 'decimal',
                      rightAlign: false,
                      allowMinus: true,
                    }"
                    v-model="funding"
                  >
                    <template #input:append>
                      <div
                        class="flex items-center justify-center space-x-2 px-4 cursor-pointer"
                        @click="onFundingClick"
                      >
                        <span class="font-bold text-primary">Пополнить</span>
                      </div>
                    </template>
                  </FormInput>
                </div>
              </div>
            </template>
          </UserProfile>
          <div class="flex flex-row items-center justify-between mt-4 py-4 px-8">
            <span class="text-danger text-16px leading-18px font-bold">
              {{ $delve(contractor, 'blockingReason') }}
            </span>
            <button
              class="btn btn-sm btn-outline-primary"
              @click="$router.push({
                name: 'contractors',
              })"
            >
              Назад
            </button>
          </div>
        </div>
      </div>
    </Loading>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import UserProfile from '@/components/User/UserProfile.vue';
import Loading from '@/components/Loading.vue';
import FormInput from '@/components/Input.vue';
import { contractorAccountFunding } from '@/api/contractors';
import { SET_CONTRACTOR_BALANCE_BY_ID } from '@/store/modules/contractors/mutation-types';

export default {
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },
  components: {
    FormInput,
    UserProfile,
    Loading,
  },
  data() {
    return {
      funding: '',
    };
  },
  computed: {
    ...mapGetters({
      contractors: 'contractors/contractors',
    }),
    waitKey() {
      return `fetch.contractor.${this.id}`;
    },
    waitPending() {
      return this.$wait.is(this.waitKey);
    },
    contractor() {
      return this.contractors(this.id);
    },
    pins() {
      return [
        {
          title: 'Выполнено заказов',
          data: this.$numeral(this.$delve(this.contractor, 'completedOrdersCount')).format('0,0'),
        },
        {
          title: 'Заработано на проекте',
          data: this.$numeral(
            parseFloat(this.$delve(this.contractor, 'completedOrdersEarnedAmount') || 0),
          ).format('0,0'),
        },
        {
          title: 'Активные заказы',
          data: this.$numeral(this.$delve(this.contractor, 'activeOrdersCount')).format('0,0'),
        },
        {
          title: 'Последний заказ',
          data: this.$options.filters.date(this.$delve(this.contractor, 'lastOrderAssignedAt')),
        },
      ];
    },
  },
  filters: {
    date(s) {
      const date = moment(s);
      if (date.isValid()) {
        return date.format('DD.MM.YYYY');
      }
      return null;
    },
  },
  methods: {
    async onFundingClick() {
      const value = this.funding;
      try {
        const response = await contractorAccountFunding(this.contractor?.id, parseFloat(value));
        const user = response?.data;
        if (user) {
          const { balance } = user;
          this.$store.commit(`contractors/${SET_CONTRACTOR_BALANCE_BY_ID}`, {
            id: this.contractor?.id,
            balance,
          });
          this.funding = '';
          this.$iwalyNotify.success({
            text: 'Баланс успешно пополнен!',
          });
        }
      } catch (e) {
        this.$iwalyNotify.error({
          text: 'Не удалось пополнить баланс',
        });
      }
    },
  },
};
</script>
